import { render } from "./FacebookPostPicker.vue?vue&type=template&id=0f03501e&scoped=true"
import script from "./FacebookPostPicker.vue?vue&type=script&lang=js"
export * from "./FacebookPostPicker.vue?vue&type=script&lang=js"

import "./FacebookPostPicker.vue?vue&type=style&index=0&id=0f03501e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f03501e"]])

export default __exports__